import { api } from "./api";

export const ScheduleList = async (addUrl = "") => {
    let url = `timetable/schedule/lists?${addUrl}`;
    return await api.get(url);
};

export const CreateSchedule = async (data) => {
    return await api.post("timetable/schedule/add", data,);
};

export const UpdateSchedule = async (data) => {
    return await api.post("timetable/schedule/update", data,);
};

export const DeleteSchedule = async (id) => {
    let url = `timetable/schedule/delete?id=${id}`;
    return await api.get(url);
};

export const TimetableList = async (addUrl = "",) => {
    let url = `timetable/list?${addUrl}`;
    return await api.get(url);
};

export const UpdateTimetable = async (data,) => {
    return await api.post("timetable/update", data,);
};

export const EnrollTimetable = async (data,) => {
    return await api.post("timetable/enroll", data,);
};

